import { render, staticRenderFns } from "./ElementTabComp.vue?vue&type=template&id=630a5191&scoped=true&"
import script from "./ElementTabComp.vue?vue&type=script&lang=js&"
export * from "./ElementTabComp.vue?vue&type=script&lang=js&"
import style0 from "./ElementTabComp.vue?vue&type=style&index=0&id=630a5191&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a5191",
  null
  
)

export default component.exports